import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row } from "react-bootstrap";
import { post } from "../../../helpers/api_helper";
import { Spin } from "antd";
import {
  successMessage,
  errorMessage,
  delete_RecordWithoutApi,
} from "../CommonFunctions";
import {
  POST_GetInventoryItemsListDLL,
  POST_GetNDTCategoryDropDownListByCategoryType,
  POST_GetEmployeeDDLList,
  POST_GetInventoryItemStockDDLListByID,
  POST_ItemWastageInsert,
  POST_ItemWastageUpdate,
  POST_GetItemWastageDetailByID,
} from "../../../helpers/url_helper";
import CustomSelect from "../../../CustomControls/CustomSelect";
import { SVGICON } from "../../../constant/theme";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import moment from "moment/moment";

const AddInventoryItemWestage = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { PrimaryIdParam } = useParams();
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const [westageReasonList, setWastageReasonList] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [itemStockOptions, setItemStockOptions] = useState([]);

  const [getInventoryItemsListDLL, setGetInventoryItemsListDLL] = useState([]);
  useEffect(() => {
    GetNDTCategoryDropDownListByCategoryTypeApi();
    getEmployeeDDL();
    getInventoryItemsListDLLApi();
    if (PrimaryIdParam) {
      getInventoryWestageDetailByID();
    }
  }, []);

  const validationSchema = Yup.object().shape({
    WastageDate: Yup.string().required("Date is required field"),
    EmployeeIDEncrypted: Yup.string()
      .trim()
      .required("Person Name is required field"),
    Listuddt: Yup.array().test(
      "has-valid-item",
      "Please add at least one valid item.",
      (list) => {
        return Array.isArray(list) && list.some((x) => x?.IsDelete !== true);
      },
    ),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      ItemWastageNo: "",
      WastageDate: new Date(),
      EmployeeIDEncrypted: "",
      Remarks: "",
      Listuddt: [],
      InventoryItemIDEncrypted: "",
      InventoryItem: "",
      IsItemStockSerialNumberWise: false,
      SerialNo: "",
      SerialNoDisplay: "",
      InventoryItemStockIDEncrypted: "",
      ItemWastageDetailsIDEncrypted: "",
      Qty: "",
      TotalAvailableQty: "",
      WastageReason: "",
      WastageReasonID: "",
      actionFlag: 0, // 0 = add, 1 = edit
      IsConsumable: false,
      CreatedByEncrypt: "",
      ModifiedByEncrypt: "",
      ConsumptionUnit: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      Listuddt,
      IsItemStockSerialNumberWise,
      actionFlag,
      WastageDate,
      ConsumptionUnit,
    },
  } = formik;

  useEffect(() => {
    if (!WastageDate) {
      formik.setFieldValue("WastageDate", "");
    }
  }, [WastageDate]);

  const GetNDTCategoryDropDownListByCategoryTypeApi = async () => {
    setIsLoading(true);
    await post(POST_GetNDTCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      NDTCategoryType: 4, // 4 is for Westage Reason
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setWastageReasonList(
            response?.List?.map((x) => ({
              label: x.NDTCategoryName,
              value: x.NDTCategoryID,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getEmployeeDDL = async () => {
    setIsLoading(true);
    await post(POST_GetEmployeeDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      UserType: AuthUser?.UserType,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setEmployeeOptions(
            response?.EmployeeList?.map((item) => ({
              label: item.EmployeeName,
              value: item.EmployeeIDEncrypted,
            })),
          );
          /*select the value when there is only one option while insert only*/
          if (response?.EmployeeList?.length == 1 && !PrimaryIdParam) {
            formik.setFieldValue(
              "IssueToEmployeeIDEncrypted",
              response?.EmployeeList[0].EmployeeIDEncrypted,
            );
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleValidSubmit = (values) => {
    setIsLoading(true);
    const payload = {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      EmployeeIDEncrypted: values?.EmployeeIDEncrypted,
      ItemWastageDate: values?.WastageDate
        ? moment(values?.WastageDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      Remarks: values?.Remarks,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ItemWastageIDEncrypted: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",

      Listuddt: values?.Listuddt?.map((item) => ({
        ItemWastageDetailsIDEncrypted:
          item?.ItemWastageDetailsIDEncrypted ?? "",
        InventoryItemIDEncrypted: item?.InventoryItemIDEncrypted,
        InventoryItemStockIDEncrypted:
          item?.InventoryItemStockIDEncrypted ?? "",
        Qty: item?.Qty.toString(),
        WastageReasonID: item?.WastageReasonID,
        IsDelete: item?.IsDelete,
      })),
    };
    // return;
    post(
      PrimaryIdParam ? POST_ItemWastageUpdate : POST_ItemWastageInsert,
      payload,
    )
      .then((response) => {
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/item-wastage");
          }, 1000);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };

  const getInventoryWestageDetailByID = () => {
    setIsLoading(true);
    post(POST_GetItemWastageDetailByID, {
      ItemWastageIDEncrypted: window.atob(PrimaryIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          const listMapped = response?.List?.map((item) => ({
            ItemWastageDetailsIDEncrypted: item?.ItemWastageDetailsIDEncrypted,
            InventoryItemIDEncrypted: item?.InventoryItemIDEncrypted,
            InventoryItemStockIDEncrypted:
              item?.InventoryItemStockIDEncrypted ?? "",
            InventoryItem: item?.ItemName ?? "",
            SerialNo: item?.SerialNumber ?? "",
            IsItemStockSerialNumberWise:
              item?.IsItemStockSerialNumberWise ?? false,
            Qty: item?.Qty?.toString() ?? "0",
            ConsumptionUnit: item?.ConsumptionUnit ?? "",
            WastageReasonID: item?.WastageReasonID ?? "",
            WastageReason: item?.WastageReason ?? "",
            IsConsumable: item?.IsConsumable ?? false,
            TotalAvailableQty: item?.TotalAvailableQty?.toString() ?? "0",
            AvailableQty: item?.AvailableQty?.toString() ?? "0",
            IsDelete: false,
          }));
          formik.setValues({
            ItemWastageNo: response?.ItemWastageNo ?? "",
            WastageDate: response?.ItemWastageDate
              ? new Date(response?.ItemWastageDate)
              : "",
            Remarks: response?.Remarks ?? "",
            EmployeeIDEncrypted: response?.EmployeeIDEncrypted ?? "",
            CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt ?? "0",
            ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt ?? "0",
            Listuddt: listMapped,
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleAddWastageDetail = () => {
    const {
      InventoryItemIDEncrypted,
      InventoryItem,
      SerialNo,
      Qty,
      ConsumptionUnit,
      TotalAvailableQty,
      IsItemStockSerialNumberWise,
      InventoryItemStockIDEncrypted,
      ItemWastageDetailsIDEncrypted,
      WastageReasonID,
      WastageReason,
      Listuddt = [],
      actionFlag,
      indexItemDetail,
    } = formik.values;

    let isValidationRequired = false;
    // Validation

    const safeQty = parseInt(Qty) || 0;
    const safeTotalQty = parseInt(TotalAvailableQty) || 0;

    if (!InventoryItemIDEncrypted) {
      formik.setFieldError("InventoryItemIDEncrypted", "Item is required");
      formik.setFieldTouched("InventoryItemIDEncrypted", true);
      isValidationRequired = true;
    }

    if (IsItemStockSerialNumberWise) {
      const serialID = formik.values.InventoryItemStockIDEncrypted;

      if (!serialID || Number(serialID) <= 0) {
        formik.setFieldError(
          "InventoryItemStockIDEncrypted",
          "Serial No is required",
        );
        formik.setFieldTouched("InventoryItemStockIDEncrypted", true, false);
        isValidationRequired = true;
      }
    } else {
      if (safeQty > safeTotalQty) {
        formik.setFieldError(
          "Qty",
          "Qty cannot be greater than the total available quantity.",
        );
        formik.setFieldTouched("Qty", true);
        isValidationRequired = true;
      }

      if (!Qty || isNaN(Qty) || parseInt(Qty) <= 0) {
        formik.setFieldError("Qty", "Qty is required");
        formik.setFieldTouched("Qty", true);
        isValidationRequired = true;
      }
    }

    if (!WastageReasonID || isNaN(WastageReasonID)) {
      formik.setFieldError("WastageReasonID", "Wastage Reason is required");
      formik.setFieldTouched("WastageReasonID", true);
      isValidationRequired = true;
    }

    const isDuplicate = Listuddt.some((item, index) => {
      if (item.IsDelete) return false; // Ignore deleted rows
      if (actionFlag === 1 && index === indexItemDetail) return false; // Skip current item in edit mode
      if (IsItemStockSerialNumberWise) {
        return (
          item.InventoryItemIDEncrypted === InventoryItemIDEncrypted &&
          item.InventoryItemStockIDEncrypted === InventoryItemStockIDEncrypted
        );
      } else {
        return item.InventoryItemIDEncrypted === InventoryItemIDEncrypted;
      }
    });

    if (isDuplicate) {
      if (IsItemStockSerialNumberWise) {
        formik.setFieldError(
          "InventoryItemStockIDEncrypted",
          "Item with this Serial No already added",
        );
        formik.setFieldTouched("InventoryItemStockIDEncrypted", true);
        isValidationRequired = true;
      } else {
        formik.setFieldError("InventoryItemIDEncrypted", "Item already exists");
        formik.setFieldTouched("InventoryItemIDEncrypted", true);
        isValidationRequired = true;
      }
      return;
    }

    if (isValidationRequired) {
      return;
    }
    // Prepare new row
    const newRow = {
      InventoryItemIDEncrypted,
      InventoryItem,
      IsItemStockSerialNumberWise,
      SerialNo: IsItemStockSerialNumberWise ? SerialNo : "",
      ItemWastageDetailsIDEncrypted: ItemWastageDetailsIDEncrypted
        ? ItemWastageDetailsIDEncrypted
        : "",
      Qty: IsItemStockSerialNumberWise ? "1" : Qty,
      ConsumptionUnit: ConsumptionUnit ? ConsumptionUnit : "",
      TotalAvailableQty,
      InventoryItemStockIDEncrypted,
      WastageReasonID,
      WastageReason,
      IsDelete: false,
    };

    if (actionFlag === 1 && indexItemDetail > -1) {
      // Update existing row
      const updatedList = Listuddt.map((item, idx) =>
        idx === indexItemDetail ? newRow : item,
      );
      formik.setFieldValue("Listuddt", updatedList);
      formik.setTouched({ ...formik.touched, Listuddt: false });
    } else {
      // Add new row
      formik.setFieldValue("Listuddt", [...Listuddt, newRow]);
      formik.setTouched({ ...formik.touched, Listuddt: false });
    }

    // Clear fields after add/update
    formik.setFieldValue("InventoryItemIDEncrypted", "");
    formik.setFieldValue("ItemWastageDetailsIDEncrypted", "");
    formik.setFieldValue("InventoryItem", "");
    formik.setFieldValue("SerialNo", "");
    formik.setFieldValue("InventoryItemStockIDEncrypted", null);
    formik.setFieldValue("Qty", "");
    formik.setFieldValue("ConsumptionUnit", "");
    formik.setFieldValue("TotalAvailableQty", "");
    formik.setFieldValue("IsItemStockSerialNumberWise", false);
    formik.setFieldValue("WastageReasonID", "");
    formik.setFieldValue("WastageReason", "");
    formik.setFieldValue("actionFlag", 0);
    formik.setFieldValue("indexItemDetail", -1);
  };

  const deleteItemDetailList = (i) => {
    if (Listuddt[i]?.InventoryItemIDEncrypted) {
      formik.setFieldValue(
        "Listuddt",
        Listuddt?.map((x, idx) => {
          if (idx == i) {
            return {
              ...x,
              IsDelete: true,
            };
          } else {
            return { ...x };
          }
        }),
      );
    } else {
      formik.setFieldValue(
        "Listuddt",
        Listuddt?.filter((x, idx) => idx != i),
      );
    }

    formik.setFieldValue("InventoryItemIDEncrypted", "");
    formik.setFieldValue("InventoryItem", "");
    formik.setFieldValue("SerialNo", "");
    formik.setFieldValue("InventoryItemStockIDEncrypted", null);
    formik.setFieldValue("Qty", "");
    formik.setFieldValue("ConsumptionUnit", "");
    formik.setFieldValue("TotalAvailableQty", "");
    formik.setFieldValue("IsItemStockSerialNumberWise", false);
    formik.setFieldValue("WastageReasonID", "");
    formik.setFieldValue("WastageReason", "");
    formik.setFieldValue("actionFlag", 0);
    formik.setFieldValue("indexItemDetail", -1);
  };

  const editItemDetailList = (indx) => {
    const editData = formik.values.Listuddt[indx];
    formik.setFieldValue("InventoryItem", editData.InventoryItem);
    formik.setFieldValue(
      "ItemWastageDetailsIDEncrypted",
      editData.ItemWastageDetailsIDEncrypted,
    );
    formik.setFieldValue(
      "InventoryItemIDEncrypted",
      editData.InventoryItemIDEncrypted,
    );
    formik.setFieldValue(
      "IsItemStockSerialNumberWise",
      editData.IsItemStockSerialNumberWise,
    );
    formik.setFieldValue(
      "InventoryItemStockIDEncrypted",
      editData.InventoryItemStockIDEncrypted,
    );
    formik.setFieldValue("Qty", editData.Qty);
    formik.setFieldValue("ConsumptionUnit", editData.ConsumptionUnit);
    formik.setFieldValue("SerialNo", editData.SerialNo);
    formik.setFieldValue("SerialNoDisplay", editData.SerialNo);
    formik.setFieldValue("TotalAvailableQty", editData.TotalAvailableQty);
    formik.setFieldValue("WastageReason", editData.WastageReason);
    formik.setFieldValue("WastageReasonID", editData.WastageReasonID);
    formik.setFieldValue("actionFlag", 1);
    formik.setFieldValue("indexItemDetail", indx);
    formik.setFieldValue(
      "InventoryItemStockIDEncrypted",
      editData.InventoryItemStockIDEncrypted
        ? editData.InventoryItemStockIDEncrypted
        : null,
    );

    // ✅ Call this to populate serial number dropdown if needed
    // For Serial No dropdown
    if (editData.IsItemStockSerialNumberWise) {
      GetItemStockDetail(editData.InventoryItemIDEncrypted);
      formik.setFieldValue("SerialNo", editData.SerialNo);
    } else {
      formik.setFieldValue("SerialNo", "");
    }
  };

  const getInventoryItemsListDLLApi = async () => {
    setIsLoading(true);
    await post(POST_GetInventoryItemsListDLL, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setGetInventoryItemsListDLL(
            response?.List?.map((item) => ({
              label: item.ItemName,
              value: item.InventoryItemIDEncrypted,
              IsItemStockSerialNumberWise: item.IsItemStockSerialNumberWise,
              IsConsumable: item.IsConsumable,
              ConsumptionUnit: item.ConsumptionUnit,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const GetItemStockDetail = (id) => {
    setIsLoading(true);
    post(POST_GetInventoryItemStockDDLListByID, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      InventoryItemIDEncrypted: id,
      IsItemWastage: true,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setItemStockOptions(
            response?.List?.map((item) => ({
              label: item.SerialNumber,
              value: item.InventoryItemStockIDEncrypted,
              UnitPrice: item?.UnitPrice,
              SerialNumber: item?.SerialNumber,
              AvailableQty: item?.AvailableQty,
            })),
          );

          let totalQty = 0;
          if (PrimaryIdParam) {
            let AvailableQtyLgt = Listuddt?.filter(
              (x) => x.IsDelete === false && x?.InventoryItemIDEncrypted === id,
            ).length;

            if (AvailableQtyLgt == 0) {
              const matchedItem = Listuddt.find(
                (item) => item.InventoryItemIDEncrypted === id,
              );

              if (matchedItem) {
                totalQty = Number(matchedItem.TotalAvailableQty) || 0;
                formik.setFieldValue("TotalAvailableQty", totalQty);
              } else {
                formik.setFieldValue(
                  "TotalAvailableQty",
                  response.List[0].TotalAvailableQty,
                );
              }
            } else {
              // formik.setFieldValue(
              //   "TotalAvailableQty",
              //   response.List[0].TotalAvailableQty
              // );
              if (actionFlag == 1) {
                formik.setFieldValue(
                  "TotalAvailableQty",
                  response.List[0].TotalAvailableQty,
                );
              } else {
                let totalQty = 0;
                const matchedItem = Listuddt.find(
                  (item) => item.InventoryItemIDEncrypted === id,
                );
                totalQty = Number(matchedItem.TotalAvailableQty) || 0;
                formik.setFieldValue("TotalAvailableQty", totalQty);
              }
            }
          } else {
            formik.setFieldValue(
              "TotalAvailableQty",
              response?.List && response.List.length > 0
                ? parseInt(response.List[0].TotalAvailableQty) +
                    parseInt(totalQty)
                : "",
            );
          }
          formik.setFieldValue("Qty", "");
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const clearItemDetailList = () => {
    formik.setFieldValue("InventoryItemIDEncrypted", "");
    formik.setFieldValue("ItemWastageDetailsIDEncrypted", "");
    formik.setFieldValue("InventoryItem", "");
    formik.setFieldValue("SerialNo", "");
    formik.setFieldValue("InventoryItemStockIDEncrypted", null);
    formik.setFieldValue("Qty", "");
    formik.setFieldValue("ConsumptionUnit", "");
    formik.setFieldValue("TotalAvailableQty", "");
    formik.setFieldValue("IsItemStockSerialNumberWise", false);
    formik.setFieldValue("WastageReasonID", "");
    formik.setFieldValue("WastageReason", "");
    formik.setFieldValue("actionFlag", 0);
    formik.setFieldValue("indexItemDetail", -1);
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">
                {PrimaryIdParam ? "Edit" : "Add"} Item Wastage
              </h4>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0">
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <Row>
                    {PrimaryIdParam && (
                      <Col lg={3}>
                        <Field
                          type="text"
                          label="Item Wastage No"
                          name="ItemWastageNo"
                          placeholder={`Enter Item Wastage No`}
                          component={CustomInput}
                          maxLength={250}
                          autoFocus
                          onChange={(e) => {
                            formik.setFieldValue(
                              "ItemWastageNo",
                              e?.target?.value,
                            );
                          }}
                          disabled={true}
                        />
                      </Col>
                    )}

                    <Col lg={3}>
                      <Field
                        label="Date"
                        name="WastageDate"
                        placeholder={"Select Date"}
                        component={CustomFlatpickr}
                        options={{
                          altInput: true,
                          altFormat: "j-M-Y",
                          dateFormat: "d-m-Y",
                        }}
                        required
                      />
                    </Col>
                  </Row>

                  <div
                    className="card-header"
                    style={{ padding: ".6rem 0rem" }}
                  >
                    <h4 className="card-title">Item Detail</h4>
                  </div>
                  <Row>
                    <Col lg={12}>
                      <Row style={{ marginTop: "10px" }}>
                        <Col lg={3}>
                          <Field
                            label="Item"
                            name="InventoryItemIDEncrypted"
                            placeholder={"Select Item"}
                            options={getInventoryItemsListDLL}
                            component={CustomSelect}
                            isClearable={false}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "InventoryItem",
                                e?.label ?? "",
                              );
                              formik.setFieldValue(
                                "InventoryItemIDEncrypted",
                                e?.value ?? 0,
                              );
                              formik.setFieldValue(
                                "IsItemStockSerialNumberWise",
                                e?.IsItemStockSerialNumberWise,
                              );
                              formik.setFieldValue(
                                "IsConsumable",
                                e?.IsConsumable,
                              );
                              formik.setFieldValue(
                                "ConsumptionUnit",
                                e?.ConsumptionUnit,
                              );
                              formik.setFieldValue("Qty", "");
                              formik.setFieldValue("AvailableQty", "");
                              GetItemStockDetail(e?.value ?? "");
                              formik.setFieldValue("WastageReason", "");
                              formik.setFieldValue("WastageReasonID", "");
                            }}
                            required
                            isDisabled={actionFlag == 1 ? true : false}
                          />
                        </Col>

                        {IsItemStockSerialNumberWise && (
                          <Col lg={3}>
                            {actionFlag != 1 ? (
                              <Field
                                label="Serial No"
                                name="InventoryItemStockIDEncrypted"
                                placeholder="Serial No"
                                options={itemStockOptions}
                                component={CustomSelect}
                                isClearable={false}
                                onChange={(e) => {
                                  formik.setFieldValue(
                                    "SerialNo",
                                    e?.SerialNumber ?? "",
                                  );
                                  formik.setFieldValue(
                                    "InventoryItemStockIDEncrypted",
                                    e?.value ?? null,
                                  );
                                }}
                                required
                              />
                            ) : (
                              <Field
                                type="text"
                                label="Serial No"
                                name="SerialNoDisplay"
                                placeholder="Enter Item Wastage No"
                                component={CustomInput}
                                maxLength={250}
                                required
                                disabled={true}
                              />
                            )}
                          </Col>
                        )}

                        {!IsItemStockSerialNumberWise && (
                          <Col lg={3}>
                            {formik?.values?.TotalAvailableQty >= 0 &&
                              !IsItemStockSerialNumberWise &&
                              ConsumptionUnit && (
                                <span
                                  className="me-2 mt-1 fs-12 text-primary"
                                  style={{ float: "right" }}
                                >
                                  Total Available Qty :{" "}
                                  {formik?.values?.TotalAvailableQty == 0
                                    ? 0
                                    : formik?.values?.TotalAvailableQty}
                                </span>
                              )}
                            <Field
                              type="number"
                              label={`Qty${
                                ConsumptionUnit ? ` (${ConsumptionUnit})` : ""
                              }`}
                              name="Qty"
                              placeholder={`Enter Qty`}
                              component={CustomInput}
                              numberTypeWithoutDot={true}
                              required
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value) && value.length <= 7) {
                                  formik.setFieldValue("Qty", value);
                                }
                              }}
                            />
                          </Col>
                        )}

                        <Col lg={3}>
                          <Field
                            label="Wastage Reason"
                            name="WastageReasonID"
                            placeholder={"Wastage Reason"}
                            options={westageReasonList}
                            component={CustomSelect}
                            isClearable={false}
                            required
                            onChange={(e) => {
                              formik.setFieldValue(
                                "WastageReason",
                                e?.label ?? "",
                              );
                              formik.setFieldValue(
                                "WastageReasonID",
                                e?.value ?? "",
                              );
                            }}
                          />
                        </Col>

                        <Col lg={2}>
                          <label style={{ marginTop: "26px" }}>
                            <button
                              type="button"
                              className="btn btn-outline-primary btn-sm"
                              onClick={(e) => {
                                handleAddWastageDetail();
                              }}
                            >
                              {actionFlag == 1 ? "Update" : "Add"}
                            </button>
                          </label>

                          {actionFlag == 1 && (
                            <label
                              style={{ marginTop: "22px", marginLeft: 10 }}
                            >
                              <button
                                type="button"
                                className="btn btn-outline-danger btn-sm"
                                onClick={(e) => {
                                  clearItemDetailList();
                                }}
                              >
                                {"Cancel"}
                              </button>
                            </label>
                          )}
                        </Col>
                      </Row>
                    </Col>

                    <Col lg={12}>
                      <div
                        className="card-body"
                        style={{ paddingLeft: 0, paddingRight: 0 }}
                      >
                        <div className="table-responsive active-projects style-1 shorting">
                          <div
                            id="ItemDetail-tbl_wrapper"
                            className="dataTables_wrapper table-responsive no-footer "
                            style={{ overflowY: "auto" }}
                            // style={{ height: "440px", overflowY: "auto" }}
                          >
                            <table
                              id="ItemDetail-tbl"
                              className="table dataTable no-footer mb-0"
                            >
                              <thead className="fixedheader">
                                <tr>
                                  <th width="3%"></th>
                                  <th width="20%">Item</th>
                                  <th width="20%">Serial No</th>
                                  <th width="20%">Qty</th>
                                  <th width="20%">Unit Name</th>
                                  <th width="17%" style={{ textAlign: "left" }}>
                                    Wastage Reason
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {Listuddt?.filter((x) => x.IsDelete === false)
                                  .length > 0 ? (
                                  Listuddt?.map((item, indx) => (
                                    <tr
                                      key={indx}
                                      style={{
                                        display:
                                          item.IsDelete === true ? "none" : "",
                                      }}
                                    >
                                      <td style={{ textAlign: "center" }}>
                                        <Link
                                          to="#"
                                          onClick={() => {
                                            editItemDetailList(indx);
                                          }}
                                          className="icon-box icon-box-md me-1"
                                          title="Edit"
                                        >
                                          {SVGICON.EditPrimary}
                                        </Link>

                                        <Link
                                          to="#"
                                          className="icon-box icon-box-md me-1"
                                          title="Delete"
                                          onClick={() => {
                                            delete_RecordWithoutApi(
                                              deleteItemDetailList,
                                              indx,
                                            );
                                          }}
                                        >
                                          {SVGICON.DeleteDanger}
                                        </Link>
                                      </td>

                                      <td>{item.InventoryItem}</td>
                                      <td>{item?.SerialNo}</td>
                                      <td>{item.Qty}</td>
                                      <td>{item.ConsumptionUnit}</td>
                                      <td style={{ textAlign: "left" }}>
                                        {item.WastageReason}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={6}
                                      style={{ textAlign: "left" }}
                                    >
                                      <div>{"No Record Found..."}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <ErrorMessage
                          name={"Listuddt"}
                          component="div"
                          className="invalid-feedback animated fadeInUp"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={3} style={{ marginTop: "6px" }}>
                      <Field
                        label="Person Name"
                        name="EmployeeIDEncrypted"
                        placeholder={"Select Person Name"}
                        options={employeeOptions}
                        component={CustomSelect}
                        isClearable={false}
                        required
                      />
                    </Col>
                    <Col lg={3} style={{ marginTop: "6px" }}>
                      <Field
                        type="text"
                        label="Remarks"
                        name="Remarks"
                        placeholder={`Enter Remarks`}
                        component={CustomInput}
                        maxLength={500}
                        onChange={(e) => {
                          formik.setFieldValue("Remarks", e.target.value);
                        }}
                      />
                    </Col>
                  </Row>
                  <hr className="mt-1 mb-2"></hr>

                  <button type="submit" className="btn btn-primary btn-sm me-2">
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </button>

                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={(e) => {
                      navigate(-1);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </Form>
              </FormikProvider>
            </div>
          </Spin>
        </div>
      </div>
    </>
  );
};

export default AddInventoryItemWestage;
